import { render } from "./image.vue?vue&type=template&id=df2d428e"
import script from "./image.vue?vue&type=script&lang=ts"
export * from "./image.vue?vue&type=script&lang=ts"

import "./image.vue?vue&type=style&index=0&id=df2d428e&lang=scss"
script.render = render

export default script